<template>
	<div class="app-container infoTab">
		<!-- 头像 -->
		<div class="maininfo">
			<div class="avatar">
				<el-image class="img" :src="userDetail.avatarUrl"></el-image>
				<div class="userName">
					{{ userDetail.userName }}
				</div>
			</div>
		</div>
		<!-- 用户资料 -->
		<div class="userdata">
			<div class="guide">
				<span class="icon">▋</span>用户资料
			</div>

			<el-descriptions title="" direction="vertical" :column="4" border>
				<el-descriptions-item label="openID">{{ userDetail.openId }}</el-descriptions-item>
				<el-descriptions-item label="昵称">{{ userDetail.nickName }}</el-descriptions-item>
				<el-descriptions-item label="姓名">{{ userDetail.userName }}</el-descriptions-item>
				<el-descriptions-item label="手机号码">{{ userDetail.mobile }}</el-descriptions-item>
				<el-descriptions-item label="生日">{{ userDetail.birthday&&userDetail.birthday.split(' ')[0] }}</el-descriptions-item>
				<el-descriptions-item label="所在城市">{{ userDetail.cityName }}</el-descriptions-item>
				<el-descriptions-item label="性别">{{ userDetail.sex == 0 ? '男': '女' }}</el-descriptions-item>
				<el-descriptions-item label="用户状态">
					<span class="statusTag success" v-if="userDetail.userStatus == '1'"> 正常 </span>
					<span class="statusTag danger" v-if="userDetail.userStatus == '2'"> 禁用 </span>
				</el-descriptions-item>
				<el-descriptions-item label="注册渠道">
					<span v-if="userDetail.regType == '1'"> 小程序 </span>
					<span v-if="userDetail.regType == '2'"> H5 </span>
				</el-descriptions-item>
				<el-descriptions-item label="注册时间">{{ userDetail.createTime }}</el-descriptions-item>
				<el-descriptions-item label="最后登录时间">{{ userDetail.loginDate }}</el-descriptions-item>
				<el-descriptions-item label=""></el-descriptions-item>
			</el-descriptions>
		</div>
		<!-- 统计信息 -->
		<div class="stats">
			<div class="guide">
				<span class="icon">▋</span>统计信息
			</div>

			<el-descriptions title="" direction="vertical" :column="4" border>
				<el-descriptions-item label="发布的赛事"> {{ userDetail.matchNum || 0}} <span class="examine"
						@click="jumpTab('hold')">查看</span></el-descriptions-item>
				<el-descriptions-item label="参与的赛事"> {{ userDetail.applyNum ||0 }} <span class="examine"
						@click="jumpTab('join')">查看</span></el-descriptions-item>
				<el-descriptions-item label="登录次数"> {{ userDetail.loginNum || 0}} <span class="examine"
						@click="jumpTab('log')"> 查看</span></el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
	import * as API_User from "@/api/sportManage/user";
	export default {
		name: "usersDetail",
		props: ["id","name"],
		components: {},
		data() {
			return {
				pageName: '用户详情',
				userDetail: {},
			};
		},
		watch: {
			name: {
				handler(newVal, oldVal) {
					if(newVal == 'info') this._getUserInfo()
				},
			}
		},
		created() {},
		methods: {
			// 接口-用户详情
			_getUserInfo() {
				API_User.userInfo({
					id: this.id
				}).then((res) => {
					this.userDetail = res.data
				}).catch((err) => {

				});
			},

			// 发布赛事跳转
			jumpTab(key) {
				this.$emit('func',key);
			},

		},
	};
</script>

<style scoped lang="scss">
	@import "../../../../assets/styles/common.scss";

	.infoTab {
		padding: 20px 0;
		.maininfo {
			display: flex;

			.img {
				width: 120px;
				height: 120px;
				border-radius: 50%;
			}

			.userName {
				margin-top: 10px;
				font-size: 16px;
				color: #666666;
				text-align: center;
				font-weight: bold;
			}

			.other {
				flex: 1;
				min-width: 0;

				.label {
					color: #999;
				}

				.value {
					line-height: 40px;
				}
			}
		}

		.datas {
			.data {
				display: flex;
				align-items: center;
				flex-direction: column;
				justify-content: center;
				flex: 1;
				min-width: 0;
				height: 100px;
				border-right: 1px solid #eee;
				color: #333;

				&:last-child {
					border: none;
				}
			}

			.label {
				color: #999;
			}

			.numb {
				font-size: 30px;
				line-height: 44px;
				font-weight: bold;
				margin-right: 20px;
			}
		}

		.tabBox {}

		//导视
		.guide {
			font-weight: bold;
			font-size: 14px;
			color: #666666;
			margin: 10px 0 10px 0;

			.icon {
				font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
				font-weight: 700;
				color: #409EFF;
				margin-right: 5px;
			}
		}

		// 查看跳转
		.examine {
			cursor: pointer;
			margin-left: 5px;
			color: rgb(64, 158, 255);
		}

	}
	
</style>
<style lang="scss">
	.infoTab {
		.datas,
		.maininfo {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			// height: 150px;
		}

		.datas {
			.el-card__body {
				height: 160px;
			}
		}
	}
</style>